<template>
  <div class="language-selector">
    <Select
      class="language-selector__input"
      v-model="current"
      :options="languages"
      optionLabel="label"
      optionValue="value"
      disabled
      :showClear="false"
    >
      <template #dropdownicon />
    </Select>
  </div>
</template>

<script>
import Select from "primevue/select";

/**
 * LanguageSelector Vue komponens
 *
 * Ez a komponens egy nyelvválasztó dropdown-t jelenít meg PrimeVue Select használatával.
 *
 * Funkciók:
 * - A választható nyelveket a $configuration rendszerből tölti be
 *   (vueJs.localization.allowed).
 * - A kiválasztott nyelvet kétirányú bindinggal kezeli (computed getter/setter).
 * - Ha a felhasználó új nyelvet választ, meghívja a $configuration.setLocale() metódust.
 * - A jelenlegi nyelvet a $configuration.getLocale() adja vissza.
 *
 * Felépítés:
 * - template: PrimeVue Select komponens
 * - computed.languages: a konfigurációból generál dropdown opciókat
 * - computed.current: kezeli az aktuális nyelvet (getter + setter)
 */

export default {
  components: { Select },

  computed: {
    /**
     * Jelenleg kizárólag a magyar nyelv jelenik meg és választható.
     *
     * Az angol és német nyelvi opciók konfiguráció szinten továbbra is elérhetők,
     * azonban üzleti igény hiányában ideiglenesen ki vannak kapcsolva.
     *
     * Később egyszerűen visszakapcsolhatók a szűrés eltávolításával.
     */
    languages() {
      let options = [];

      _.forEach(this.$configuration.get("vueJs.localization.allowed"), (value, key) => {
        if (key === "hu") {
          options.push({
            label: value,
            value: key,
          });
        }
      });

      return options;
    },

    current: {
      set(value) {
        this.$configuration.setLocale(value);
      },
      get() {
        return this.$configuration.getLocale();
      },
    },
  },
};
</script>
<style scoped>
/**
 * A nyelvválasztó jelenleg szándékosan van letiltva,
 * mert jelen állapotban kizárólag a magyar nyelv használata szükséges.
 *
 * Az angol és német lokalizáció konfiguráció szinten továbbra is elérhető,
 * így később egyszerűen visszakapcsolható.
 */
.language-selector {
  display: inline-block;
  cursor: not-allowed;
}

.language-selector__input {
  pointer-events: none;
}

.language-selector :deep(.p-select) {
  cursor: not-allowed;
}

.language-selector :deep(.p-select-label) {
  cursor: not-allowed;
}

.language-selector :deep(.p-select-dropdown) {
  display: none;
}
</style>
